import React from 'react';
import JsxParser from 'react-jsx-parser/lib/es5/react-jsx-parser.min';
import clsx from 'clsx';
import Button from '../../components/Button/Button';
import ContentPage from '../../components/Section/ContentPage';

const DynamicMessage = (props) => {
  const { text } = props;
  return (
    <JsxParser
      bindings={{
        ...props,
        clsx,
      }} jsx={text} components={{ Button, ContentPage }}
    />
  );
};

export default DynamicMessage;